import React from 'react';

import { useAppSelector } from '@/store';

import { Banner } from './VerifyEmailBanner.styles';

/**
 * Shown across the studio chrome while the signed-in owner's email is unverified
 * (`email_verified === false`, set only after a Telegram signup that has not confirmed its mailbox —
 * see sso.md). It only prompts; the deploy/activation step is gated separately (see the configurator).
 * `null` / `true` never render it.
 */
export const VerifyEmailBanner = (): React.ReactElement | null => {
  const unverified = useAppSelector(
    (state) => state.authentication.auth_type === 'user' && state.authentication.user.email_verified === false,
  );
  if (!unverified) {
    return null;
  }
  return (
    <Banner
      tone="info"
      icon="mail"
      text="Verify your email to unlock brand deployment. Check your inbox for the confirmation link."
    />
  );
};

export default VerifyEmailBanner;
